import { gql } from 'graphql-request'

export const Q_USER_PAYMENT_METHODS = gql`
  query UserPaymentMethods {
    userPaymentMethods {
      ... on PaymentMethodList {
        paymentMethods {
          id
          brand
          last4
          expMonth
          expYear
          isDefault
        }
      }
      ... on QueryFailure {
        errors {
          message
        }
      }
    }
  }
`

export const M_CREATE_SETUP_INTENT = gql`
  mutation CreateSetupIntent {
    createSetupIntent {
      ... on SetupIntentResult {
        clientSecret
      }
      ... on QueryFailure {
        errors {
          message
        }
      }
    }
  }
`
